import { render, staticRenderFns } from "./invoiceAddApprove.vue?vue&type=template&id=5d12f222"
import script from "./invoiceAddApprove.vue?vue&type=script&lang=js"
export * from "./invoiceAddApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports